import * as React from 'react';
import PropTypes from 'prop-types';

export default class ButtonComponent extends React.Component {
    static CONTEXT = {
        DANGER: 'danger',
        DEFAULT: 'default',
        INFO: 'info',
        LINK: 'link',
        PRIMARY: 'primary',
        SUCCESS: 'success',
        WARNING: 'warning',
    }

    render() {
        const className = `btn btn-${this.props.context} ${this.props.className || ''}`;

        return (
            <button
                className={className}
                disabled={this.props.disabled}
                id={this.props.id}
                name={this.props.name}
                onClick={this.props.onClick}
                placeholder={this.props.placeholder}
                required={this.props.required}
                title={this.props.title}
                type={this.props.submit ? 'submit' : ''}>
                {this.props.children}
            </button>
        );
    }
}

ButtonComponent.propTypes = {
    className: PropTypes.string,
    context: PropTypes.oneOf([
        ButtonComponent.CONTEXT.DANGER,
        ButtonComponent.CONTEXT.DEFAULT,
        ButtonComponent.CONTEXT.INFO,
        ButtonComponent.CONTEXT.LINK,
        ButtonComponent.CONTEXT.PRIMARY,
        ButtonComponent.CONTEXT.SUCCESS,
        ButtonComponent.CONTEXT.WARNING
    ]),
    disabled: PropTypes.bool,
    id: PropTypes.string,
    name: PropTypes.string,
    onClick: PropTypes.func,
    required: PropTypes.bool,
    submit: PropTypes.bool,
    title: PropTypes.string
}

ButtonComponent.defaultProps = {
    context: ButtonComponent.CONTEXT.DEFAULT
}


// WEBPACK FOOTER //
// ./src/component/form/button/button-component.js